// @flow
import * as React from 'react';
import { Avatar } from '@ta/styleguide.avatar';
import type { Source as ResponsiveImageSource } from '@ta/media.image';
import { localize } from '@ta/common.i18n';
import { useMentionsInteractionContext } from '@ta/social.mentions-tracking';
import ProfileLabel from './ProfileLabel';
import ActorSocialCounts from './ActorSocialCounts';
import styles from './MentionsCardHeader.less';

type Props = {|
  avatar?: ResponsiveImageSource[],
  actorUrl?: string,
  displayName?: string,
  isVerified?: boolean,
  contributionCount?: number,
|};

const MentionsCardHeader = ({
  actorUrl,
  avatar,
  displayName = localize('native_login_user_review_anonymous') /* A TripAdvisor Member */,
  isVerified,
  contributionCount,
}: Props) => {
  const InteractionTracking = useMentionsInteractionContext();
  return (
    <>
      <Avatar
        photo={avatar ? { photoSizes: avatar } : undefined}
        display="inline"
        href={actorUrl}
        withBorder
        onClick={InteractionTracking.userClick || undefined}
      />
      <div className={styles.header}>
        <ProfileLabel name={displayName} url={actorUrl} isVerified={isVerified} />
        <ActorSocialCounts contributionCount={contributionCount} />
      </div>
    </>
  );
};
/** The MentionsCardHeader component */
export default React.memo<Props>(MentionsCardHeader);
